import {IntermediatePart} from "../../intermediatePart";

export default class TowelRack extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'towel_rack';
    this.partName = 'Towel Rack';
    this.translateId = "visualizer.bathroom.accessories.towel_rack";
    this.canBeDisabled = true;
  }
}
